export const VarIncident = {
  GENERIC: 'GENERIC',
  GOAL: 'GOAL',
  NO_GOAL: 'NO_GOAL',
  PENALTY: 'PENALTY',
  NO_PENALTY: 'NO_PENALTY',
  RED_CARD: 'RED_CARD',
  NO_RED_CARD: 'NO_RED_CARD',
  PENALTY_KICK: 'PENALTY_KICK',
} as const;
export type VarIncident = (typeof VarIncident)[keyof typeof VarIncident];

export const VarReason = {
  NONE: 'NONE',
  OFFSIDE: 'OFFSIDE',
  ATTACKING_FOUL: 'ATTACKING_FOUL',
  ATTACKING_HAND_BALL: 'ATTACKING_HAND_BALL',
  BALL_CROSS_LINE: 'BALL_CROSS_LINE',
  BALL_OUT_OF_PLAY: 'BALL_OUT_OF_PLAY',
  FOUL: 'FOUL',
  FOUL_INSIDE: 'FOUL_INSIDE',
  HAND_BALL: 'HAND_BALL',
  HAND_BALL_INSIDE: 'HAND_BALL_INSIDE',
  DOGSO: 'DOGSO',
  MISTAKEN_IDENTITY: 'MISTAKEN_IDENTITY',
  GOALKEEPER_OFFENCE: 'GOALKEEPER_OFFENCE',
  IRREGULAR_KICK: 'IRREGULAR_KICK',
  ENCROACHMENT: 'ENCROACHMENT',
} as const;
export type VarReason = (typeof VarReason)[keyof typeof VarReason];

export const VarResult = {
  NONE: 'NONE',
  PENALTY_RETAKEN: 'PENALTY_RETAKEN',
  INDIRECT_KICK: 'INDIRECT_KICK',
  GOAL: 'GOAL',
  PENALTY: 'PENALTY',
  RED_CARD: 'RED_CARD',
  MISTAKEN_IDENTITY: 'MISTAKEN_IDENTITY',
  NO_PENALTY: 'NO_PENALTY',
  NO_GOAL: 'NO_GOAL',
  NO_RED_CARD: 'NO_RED_CARD',
  NO_OFFENCE: 'NO_OFFENCE',
  FOUL: 'FOUL',
  YELLOW_CARD: 'YELLOW_CARD',
} as const;
export type VarResult = (typeof VarResult)[keyof typeof VarResult];

export const VarStatus = {
  SILENT_CHECK: 'SILENT_CHECK',
  OFFICIAL_REVIEW: 'OFFICIAL_REVIEW',
  CONFIRMED: 'CONFIRMED',
  CHANGED: 'CHANGED',
} as const;
export type VarStatus = (typeof VarStatus)[keyof typeof VarStatus];
